const BodyParts = {
  pelvis: 'Pelvis',
  torso: 'Torso',
  upperArm: 'UpperArm',
  lowerArm: 'LowerArm',
  hand: 'Hand'
};

export default BodyParts;
